module.exports = __webpack_public_path__ + "static/media/verhaltensbasiert_step_6.4423d088.png";